import { Dayjs } from "dayjs";
import { PaginationDetails } from "./api_request";

export interface PostJobProps {
  job_title: string;
  work_location: string;
  job_description: string;
  department: string;
  how_to_apply: string;
  application_deadline: string;
  job_type: string;
  qualifications: string;
  employment_type: string;
  experience_level: string;
  work_schedule: string;
  additional_info: string;
  work_type: string;
  contract_duration: string;
}

export interface PostJobPropsType {
  job_title: string;
  work_location: string;
  job_description: string;
  department: string;
  how_to_apply: string;
  job_type: string;
  qualifications: string;
  employment_type: string;
  experience_level: string;
  work_schedule: string;
  work_type: string;
  contract_duration: string;
  required_documents: string[];
  salary_range: {
    min: string;
    max: string;
  };
  application_deadline: string | undefined;
}

export interface JobBoardProps {
  jobList: JobListProps[];
  isLoading: boolean;
  stats: JobStatsProps;
  setFilterData: React.Dispatch<React.SetStateAction<string>>;
  paginationState: PaginationDetails;
  setPaginationState: React.Dispatch<React.SetStateAction<PaginationDetails>>;
}

export interface JobIdProps {
  jobId: string;
}

export interface JobIdDetailsProps {
  additional_info: string;
  application_deadline: string;
  contract_duration: string;
  createdAt: string;
  employment_type: string;
  experience_level: string;
  facility: string;
  facility_info: { name: string; avatar: string };
  how_to_apply: string;
  job_description: string;
  job_title: string;
  job_type: string;
  department: string;
  salary_range: string;
  required_documents: string;
  stats: {
    number_of_applicants: number;
    pending_reviews: number;
    shorlisted_candidates: number;
    upcoming_interviews: number;
  };
  status: string;
  updatedAt: string;
  work_location: string;
  work_schedule: string;
  work_type: string;
  _id: string;
}

// Default values for JobIdDetailsProps
export const defaultJobDetails: JobIdDetailsProps = {
  additional_info: "",
  application_deadline: "",
  contract_duration: "",
  createdAt: "",
  employment_type: "",
  experience_level: "",
  facility: "",
  facility_info: {
    name: "",
    avatar: "",
  },
  salary_range: "",
  how_to_apply: "",
  job_description: "",
  job_title: "",
  job_type: "",
  department: "",
  required_documents: "",
  stats: {
    number_of_applicants: 0,
    pending_reviews: 0,
    shorlisted_candidates: 0,
    upcoming_interviews: 0,
  },
  status: "",
  updatedAt: "",
  work_location: "",
  work_schedule: "",
  work_type: "",
  _id: "",
};

export interface JobStatsProps {
  metrics: {
    employmentTypeDistribution: [
      {
        type: string;
        count: number;
      },
    ];
    metrics: {
      totalApplicants: number;
      totalPendingReviews: number;
      totalShortlisted: number;
      totalUpcomingInterviews: number;
      rejectionRate: number;
      acceptanceRate: number;
      conversionRate: number;
    };
  };
  totalDocuments: number;
}

export const JobStatsDummy = {
  metrics: {
    employmentTypeDistribution: [
      {
        type: "",
        count: 0,
      },
    ],
    metrics: {
      totalApplicants: 0,
      totalPendingReviews: 0,
      totalShortlisted: 0,
      totalUpcomingInterviews: 0,
      rejectionRate: 0,
      acceptanceRate: 0,
      conversionRate: 0,
    },
  },
  totalDocuments: 0,
};

export interface JobListProps {
  _id: string;
  job_type: string;
  job_title: string;
  department: string;
  job_description: string;
  qualifications: string;
  experience_level: string;
  employment_type: string;
  work_schedule: string;
  contract_duration: string;
  work_location: string;
  work_type: string;
  salary_range: string;
  application_deadline: string;
  additional_info: string;
  required_documents: string;
  how_to_apply: string;
  facility: string;
  facility_info: {
    name: string;
    avatar: string;
  };
  status: string;
  stats: {
    number_of_applicants: number;
    pending_reviews: number;
    shorlisted_candidates: number;
    upcoming_interviews: number;
    rejected_candidates: number;
    accepted_candidates: number;
  };
  created_at: string;
  updated_at: string;
}
